<template>
  <div class="layout" v-if="clubActual && clubActual.id">
    <div v-if="titulosProyectos.length > 0" class="layout-content d-flex flex-column flex-md-row">
      <!-- Sidebar -->
      <CultivoSidebar class="sidebar flex-shrink-0" :proyecto="proyecto" :titulosProyectos="titulosProyectos"
        :planes_de_cultivo="planes_de_cultivo" :activeTab="activeTab" @update:activeTabProyectoGestion="updateActiveTab"
        @select-project="selectProject" @select-evento="selectEvento" @select-lote="selectLote" @create-lote="crearLote"
        @create-evento="crearEvento" @select-administrarProyecto="selectAdministrarProyecto"
        @select-verPlan="selectVerPlan" @select-moverPlantasASalas="selectMoverPlantasASalas" />

      <!-- Contenido principal -->
      <div class="content-area">
        <!-- Mensaje de aviso según pestaña y selección -->
        <template v-if="mensajeEvento && activeTab === 'eventos'">
          <div class="alert alert-warning text-center">
            {{ mensajeEvento }}
          </div>
        </template>
        <template v-else-if="mensajeLote && activeTab === 'lotes'">
          <div class="alert alert-warning text-center">
            {{ mensajeLote }}
          </div>
        </template>

        <!-- Alta de evento -->
        <template v-else-if="activeTab === 'createEvento'">
          <altaEventoProyecto :proyecto_id="proyecto.id" @eventoCreado="agregarEventoCreado" />
        </template>

        <!-- Vistas principales -->
        <template v-else>
          <!-- Vista de Plan -->
          <template v-if="activeTab === 'cultivo'">
            <div class="d-flex gap-2" style="margin-bottom: 0.5rem;"> <!-- más compacto -->
              <button class="btn btn-outline-primary" :class="{ active: planViewMode === 'vsreal' }"
                @click="planViewMode = 'vsreal'">
                📊 Plan VS Real
              </button>
              <button class="btn btn-outline-secondary" :class="{ active: planViewMode === 'actual' }"
                @click="planViewMode = 'actual'">
                📋 Ver Plan Actual
              </button>
            </div>

            <transition name="fade" mode="out-in">
              <template v-if="planViewMode === 'actual'">
                <template v-if="planSeleccionado">
                  <VistaPlan :plan="planSeleccionado" />
                </template>
                <template v-else>
                  <div class="alert alert-info text-center">
                    No hay un plan de cultivo activo o actual. Para comenzar, seleccioná un plan haciendo clic en
                    <strong>"Trabajar con este plan"</strong> dentro del módulo de <strong>Navegación</strong> a la
                    izquierda del proyecto.
                  </div>
                </template>
              </template>

              <template v-else-if="planViewMode === 'vsreal'">
                <template v-if="planSeleccionado">
                  <PlanVsReal :plan="planSeleccionado" />
                </template>
                <template v-else>
                  <div class="alert alert-info text-center">
                    No hay un plan de cultivo activo o actual. Para comparar, seleccioná un plan haciendo clic en
                    <strong>"Trabajar con este plan"</strong> dentro del módulo de <strong>Navegación</strong> a la
                    izquierda del proyecto.
                  </div>
                </template>
              </template>

            </transition>
          </template>

          <!-- Vista de Evento -->
          <template v-else-if="activeTab === 'eventos'">
            <transition name="fade" mode="out-in">
              <verEvento v-if="eventoIdSeleccionado" :proyecto_evento_id="eventoIdSeleccionado"
                :proyecto_id="proyecto.id" />
            </transition>
          </template>

          <!-- Otras rutas hijas (Lotes, etc.) -->
          <template v-else>
            <template v-if="vistaActual === 'verLote'">
              <VistaLote :proyecto_id="proyecto.id" :lote_id="loteIdSeleccionado" @volver="vistaActual = 'eventos'" />
            </template>

            <template v-else-if="vistaActual === 'altaLote'">
              <AltaLote :proyecto_id="proyecto.id" @lote-creado="loteCreado" @volver="vistaActual = 'eventos'" />
            </template>

            <template v-else-if="vistaActual === 'administrarProyecto'">
              <AdministrarProyecto :proyecto_id="proyecto.id" @volver="vistaActual = 'eventos'" />
            </template>

            <template v-else-if="vistaActual === 'salaGestion'">
              <SalaGestion :proyecto_id="proyecto.id" @volver="vistaActual = 'eventos'" />
            </template>
          </template>
        </template>
      </div>
    </div>

    <div v-else class="no-project-wrapper">
      <div class="no-project-message">
        <font-awesome-icon icon="exclamation-circle" class="me-2" />
        No tenés proyectos de cultivo creados.<br />
        <small>Crea uno para comenzar a operar el cultivo.</small>
      </div>
    </div>

  </div>

  <div v-else class="no-club-message">
    <p>
      No tienes un club vinculado a tu usuario. Por favor, solicita la vinculación de tu
      usuario a un club para empezar a registrar la operación diaria.
    </p>
  </div>
</template>

<script>
import axios from '@/axios';
import CultivoSidebar from './CultivoSidebar.vue';
import VistaPlan from '@/components/PlanCultivo/VistaPlan.vue';
import PlanVsReal from '@/components/PlanVSReal/PlanVsReal.vue';
import altaEventoProyecto from '@/components/Evento/alta-eventoProyecto.vue';
import verEvento from '@/components/Evento/ver-evento.vue';
import VistaLote from '@/components/Lote/ver-lote.vue';
import AltaLote from '@/components/Lote/alta-lote.vue';
import AdministrarProyecto from '@/components/Proyecto/AdministrarProyecto.vue';
import SalaGestion from '@/views/SalaPlanta/SalasGestion.vue';




export default {
  name: 'ProyectoGestion',
  components: {
    CultivoSidebar,
    VistaPlan,
    PlanVsReal,
    altaEventoProyecto,
    verEvento,
    VistaLote,
    AltaLote,
    AdministrarProyecto,
    SalaGestion,
  },
  props: {
    proyecto_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {

      proyecto: {},
      titulosProyectos: [],
      planes_de_cultivo: [],
      planSeleccionado: null,
      activeTab: 'eventos',
      vistaActual: 'eventos', // eventos | verLote | altaLote | administrarProyecto | salaGestion
      planViewMode: 'vsreal', // 'vsreal' | 'actual'
      clubActual: this.$store.getters.getClubActual,
      mensajeEvento: '',
      mensajeLote: '',
      eventoSeleccionado: null,
      eventoIdSeleccionado: null,
      loteSeleccionado: null,
      loteIdSeleccionado: null,
    };
  },
  async mounted() {
    try {
      if (!this.clubActual?.id) return console.error('No se tiene vinculado ningún club');
      const { data } = await axios.get('/api/proyectos', {
        params: { club_id: this.clubActual.id },
      });
      this.titulosProyectos = data;
      if (!this.titulosProyectos.length) {
        this.$store.commit('limpiarProyectoActual');
        return console.warn('No hay proyectos disponibles');
      }
      const actual = this.$store.getters.getProyectoActual;
      await this.selectProject(actual?.id ? actual : this.titulosProyectos[0]);
      await this.obtenerPlanesDeCultivo();
    } catch (err) {
      console.error('Error al montar ProyectoGestion:', err);
    }
  },
  methods: {
    async selectProject(unProyecto) {
      try {
        const id = unProyecto.id;
        const { data } = await axios.get(`/api/proyectos/${id}`);
        this.proyecto = data;
        this.$store.commit('setProyectoActual', this.proyecto);
        // Reset estados
        this.mensajeEvento = '';
        this.mensajeLote = '';
        this.loteSeleccionado = null;
        this.loteIdSeleccionado = null;
        // Inicializar plan
        this.planSeleccionado = null;
        this.planSeleccionado = this.planes_de_cultivo
          ? this.planes_de_cultivo.find(p => p.id === this.proyecto.plan_cultivo_id) || null
          : null;
        // Si tiene eventos, selecciona el último y muéstralo
        if (Array.isArray(this.proyecto.proyecto_evento) && this.proyecto.proyecto_evento.length) {
          const ultimo = this.proyecto.proyecto_evento.slice(-1)[0];
          this.eventoSeleccionado = ultimo;
          this.eventoIdSeleccionado = ultimo.id;
        } else {
          this.eventoSeleccionado = null;
          this.eventoIdSeleccionado = null;
        }
        this.activeTab = 'eventos';
      } catch (err) {
        console.error('Error al seleccionar proyecto:', err);
      }
    },
    async obtenerPlanesDeCultivo() {
      try {
        const { data } = await axios.get('/api/planes_cultivo', {
          params: { club_id: this.clubActual.id },
        });
        this.planes_de_cultivo = data;
        // Si ya tenemos proyecto y plan_id, asegurar planSeleccionado
        if (this.proyecto.plan_cultivo_id) {
          this.planSeleccionado = this.planes_de_cultivo.find(
            p => p.id === this.proyecto.plan_cultivo_id
          ) || this.planSeleccionado;
        }
      } catch (err) {
        console.error('Error al cargar planes de cultivo:', err);
      }
    },
    agregarEventoCreado(evento) {
      if (!this.proyecto.proyecto_evento) this.proyecto.proyecto_evento = [];
      this.proyecto.proyecto_evento.push(evento);
      this.eventoSeleccionado = evento;
      this.eventoIdSeleccionado = evento.id;
      this.mensajeEvento = '';
      this.activeTab = 'eventos';
    },
    selectEvento(evento) {
      this.activeTab = 'eventos';
      if (!evento?.id) {
        this.mensajeEvento =
          'No se ha seleccionado un evento o debe crear uno para comenzar a cargar tareas operativas';
        return;
      }
      this.mensajeEvento = '';
      this.eventoSeleccionado = evento;
      this.eventoIdSeleccionado = evento.id;
    },
    selectLote(lote) {
      if (!lote?.id) {
        this.mensajeLote = 'No se ha seleccionado un lote...';
        return;
      }
      this.mensajeLote = '';
      this.loteSeleccionado = lote;
      this.loteIdSeleccionado = lote.id;
      this.vistaActual = 'verLote';
    },
    loteCreado(lote) {
      if (!this.proyecto.lotes) this.proyecto.lotes = [];
      this.proyecto.lotes.push(lote);
      this.loteSeleccionado = lote;
      this.loteIdSeleccionado = lote.id;
      this.mensajeLote = '';
      this.selectLote(lote);
    },
    crearLote() {
      if (!this.proyecto.id) return;
      this.mensajeLote = '';
      this.vistaActual = 'altaLote';
    },
    crearEvento() {
      if (!this.proyecto.id) return;
      this.mensajeEvento = '';
      this.activeTab = 'createEvento';
    },
    selectAdministrarProyecto() {
      this.vistaActual = 'administrarProyecto'
    },
    selectVerPlan(plan) {
      if (!plan?.id) return;
      this.planSeleccionado = this.planes_de_cultivo.find(
        p => p.id === this.proyecto.plan_cultivo_id
      ) || this.planSeleccionado;

    },
    selectMoverPlantasASalas() {
      this.vistaActual = 'salaGestion'
    },
    updateActiveTab(tab) {
      this.activeTab = tab;
    },
  },
};
</script>

<style scoped>
:root {
  --sidebar-bg: #f8f9fa;
  --content-bg: #ffffff;
  --box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  --padding: 20px;
}

.layout {
  display: flex;
  height: 100vh;
  /* Ocupa toda la altura de la ventana */
  width: 100%;
  /* Asegura que ocupe todo el ancho disponible */
  /* Previene desbordamientos visuales */
}

.layout-content {
  display: flex;
  /* Distribuye los elementos en fila */
  flex-grow: 1;
  flex-direction: row;
  /* solo en pantallas grandes */

  /* Permite que este contenedor crezca */
  width: 100%;
  /* Asegura que no exceda el ancho del contenedor principal */
  overflow: hidden;
  /* Previene desbordamientos visuales */
  min-height: 100vh;
  gap: 0px; /* default desktop */

  /* Mobile: eliminar espacio entre columnas */
  @media (max-width: 767.98px) {
    gap: 0 !important;
  }

}

.layout-content > * {
  width: 100%;
  box-sizing: border-box;
}

.layout-content > * {
  flex-grow: 1;
}

@media (max-width: 767.98px) {
  .layout-content {
    flex-direction: column !important;
    overflow: visible !important;
  }

  .content-area {
    overflow: visible !important;
    flex-grow: 1;
    width: 100%;
  }
}

.sidebar {
  width: 300px;
  max-width: 100%;
  min-width: 300px;
  background-color: var(--sidebar-bg);
  box-shadow: var(--box-shadow);
  overflow-y: auto;
  padding: 0.5rem 0.75rem;
  /* menos padding vertical */

  /* Agrega desplazamiento si el contenido es más alto */
}

@media (max-width: 767.98px) {
  .sidebar {
    width: 100%;
  }
}

.content-area {
  flex-grow: 1;
  /* Ocupa el espacio restante */
  flex-shrink: 1;
  /* Permite que se reduzca si el espacio es limitado */
  min-width: 0;
  /* Previene que el contenido interno cause un desbordamiento */
  overflow-x: auto;
  overflow-y: auto;

  /* Habilita desplazamiento horizontal si es necesario */
  word-wrap: break-word;
  overflow-wrap: break-word;
  padding: 0 !important;
  margin: 0 !important;
}

@media (max-width: 767.98px) {
  .content-area {
    overflow-x: visible;
    overflow-y: visible;
  }
}


.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.no-club-message {
  text-align: center;
  padding: 20px;
  color: #fff;
  background-color: #ff6f61;
  font-size: 1.2rem;
  border-radius: 8px;
  margin: 50px auto;
  max-width: 600px;
}

.no-project-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  /* centrado vertical según el alto visible */
  width: 100%;
}

.no-project-message {
  background-color: #3ca1e4;
  color: #fff;
  padding: 20px 30px;
  border-radius: 10px;
  font-size: 1.2rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  max-width: 400px;
  text-align: center;
}

.no-project-message small {
  display: block;
  font-size: 0.9rem;
  margin-top: 5px;
  color: #eaf6ff;
}
</style>
